<template>
  <span  v-for="(value, index) in values" :key="index">
    <span v-if="values.length > 1 && value.label" v-html="value.label + ': ' "></span>

    <template v-if="Array.isArray(value.text)" v-for="(textItem, textItemIndex) in value.text">
      <a v-if="textItem.url" :href="textItem.url" v-html="textItem.text"></a>
      <span v-else>{{textItem.text}}</span><span v-if="textItemIndex < value.text.length - 1 && value.text[textItemIndex+1]">, </span>
    </template>

    <template v-else >
      <a v-if="value.url" :href="value.url" v-html="value.text"></a>
      <span v-else v-html="value.text"></span>
    </template>
    <span v-if="index < values.length - 1 && values[index+1].text" v-html="separator" />
  </span>
</template>

<script>
export default {
  name: 'FactSectionValues',
  props: {
    values: {
      type: Array,
      required: true,
    },
    separator: {
      type: String,
      default: ' | ',
    },
  },
};
</script>
